import { ConsumptionProjectionMaterialItemRead } from "src/store/api/generatedApi";

export const withUpdatedRowFractions = (
  rows: ConsumptionProjectionMaterialItemRead[]
): ConsumptionProjectionMaterialItemRead[] => {
  // Treat NaN, null, undefined as 0 for calculations
  const safeQuantity = (quantity: number): number => {
    return Number.isFinite(quantity) ? quantity : 0;
  };

  const totalQuantity = rows.reduce(
    (acc, row) => acc + safeQuantity(row.quantity),
    0
  );

  if (totalQuantity === 0) {
    return rows.map((row) => ({ ...row, fraction: 0 }));
  }

  return rows.map((row) => ({
    ...row,
    fraction: safeQuantity(row.quantity) / totalQuantity,
  }));
};
